<template>
  <common-markdown-preview :content="showText" :options="options"></common-markdown-preview>
</template>

<script>
import CommonMarkdownPreview from '../../../components/common/common-markdown-preview.vue';

export default {
  components: {
    CommonMarkdownPreview,
  },
  props: {
    text: {
      type: String,
      default: '',
    },
    status: {
      type: Number,
      default: 0,
    },
    defaultIndex: {
      type: Number,
      default: 0,
    },
    options: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      index: 0,
      timer: null,
    };
  },
  computed: {
    showText() {
      if (!this.text) return '';
      if ([2, 3].includes(this.status)) return this.text;
      return this.text.substring(0, this.index);
    },
  },
  watch: {
    text: {
      handler() {
        if (this.index < this.text.length) {
          this.startLoop();
        }
      },
      immediate: true,
    },
    status: {
      handler() {
        if ([2, 3].includes(this.status)) {
          clearInterval(this.timer);
        }
      },
      immediate: true,
    },
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.index = this.defaultIndex;
    },
    // 添加文本一次
    addTextOnce(onceIndex = 1) {
      this.index += onceIndex;
    },
    startLoop() {
      clearInterval(this.timer);
      this.timer = setTimeout(() => {
        if (this.index < this.text.length) {
          const diff = this.text.length - this.index;
          const onceIndex = Math.floor(diff / 10) + 1;
          this.addTextOnce(onceIndex);
          this.startLoop();
        }
      }, 50);
    },
  },
};
</script>

<style lang="less" scoped></style>



// WEBPACK FOOTER //
// src/pages/chat-visa/components/chat-item-answer-message.vue